import isEmpty from "lodash.isempty";
import qs from "qs";

import {
  allowedBoxLinkFilters,
  allowedFilters,
  allowedQueryFilters,
} from "../../../stores/FiltersStore";
import pick from "../pick/pick";

const getFilters = async (query, _locale, boxLinksMapping = null) => {
  const mapping = boxLinksMapping ?? {};

  const parsedQuery = qs.parse(query);

  const queryFilters = pick(parsedQuery, allowedQueryFilters);

  const mappedFilters = allowedBoxLinkFilters.reduce((acc, curr) => {
    if (curr in queryFilters) {
      const queryFilter = queryFilters[curr];

      const mappedFilterName = mapping[queryFilter]?.filterName;
      const mappedFilterValue = mapping[queryFilter]?.filterValue;

      if (mappedFilterName && !isEmpty(mappedFilterValue)) {
        acc[mappedFilterName] = mappedFilterValue;
      }
    }

    return acc;
  }, {});

  const mergedFilters = { ...queryFilters, ...mappedFilters };

  return pick(mergedFilters, allowedFilters);
};

export default getFilters;
